/**
 * 是否为汉字
 * @param {String} val 值
 * @returns 是否为汉字
 */
const isChinese = val => /[\u4e00-\u9fa5]/.test(val)

/**
 * 获取字符长度
 * @param {String} val 字符 
 * @returns 字符长度
 */
const getLen = val => {
    if (!val) return 0
    let len = 0
    for (let s of val) {
        len += isChinese(s) ? 1 : 1
    }
    return len
}

/**
 * 校验数字
 * @param {String} name 字段名
 * @param {String} val 值
 * @param {Function} callback 
 * @returns 检验提示
 */
const validNum = (name, val, callback) => (/[^0-9]/).test(val) && callback(`【${name}】仅限数字`)

/**
 * 校验小数
 * @param {String} name 字段名
 * @param {String} val 值
 * @param {Function} callback 
 * @param {Boolean} allowNegative 是否允许负数
 * @returns 检验提示
 */
const validDecimal = (name, val, callback, allowNegative) => !new RegExp(`^[+${allowNegative ? '-' : ''}]?(0|([1-9]\\d*))(\\.\\d+)?$`).test(val) && callback(`【${name}】仅限整数或小数`)

/**
* 校验是否为数字或字母
* @param {String} name 字段名
* @param {String} val 值
* @param {Function} callback 
* @returns 检验提示
*/
const validNumOrLetter = (name, val, callback) => (/[^0-9a-zA-Z]/).test(val) && callback(`【${name}】仅限数字和字母`)

/**
 * 校验是否为字母或汉字
 * @param {String} name 字段名
 * @param {String} val 值
 * @param {Function} callback 
 * @returns 检验提示
 */
const validLetterOrChinese = (name, val, callback) => (/[^a-zA-Z\u4e00-\u9fa5]/).test(val) && callback(`【${name}】不可使用数字及标点符号`)

/**
 * 校验是否为手机号
 * @param {String} val 值
 * @returns 检验提示
 */
const validCellPhone = (val) => (/^1\d{10}$/).test(val)

/**
* 校验面貌格式
* @param {String} val 值
* @returns 检验提示
*/
const validNewPassword = (val) => (/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}/g).test(val)

/**
 * 获取必填的校验提示
 * @param {String} name 字段名
 * @returns 校验提示
 */
const getRequiredMsg = name => (name && `【${name}】`) + '不允许为空'

/**
 * 获取空白的校验提示
 * @param {String} name 字段名
 * @returns 校验提示
 */
const getBlankMsg = name => `【${name}】不允许为全空格`

/**
 * 获取字符长度的校验提示
 * @param {String} name 字段名
 * @param {Number} len 字符长度
 * @returns 校验提示
 */
const getLenMsg = (name, len) => `【${name}】不允许超过${len}个字符`

/**
 * 判断是否需要校验数组中某一项数据
 * @param {String} currentIndex 当前下标
 * @param {Object} currentRow 当前数据
 * @param {Number} requiredNum 必填项的数量
 * @param {String} keyName 主键名称
 * @returns
 */
const needValidate = (currentIndex, currentRow, requiredNum = 0, keyName = 'ids') => {
    return currentIndex < requiredNum || Object.entries(currentRow).filter(([key, val]) => key !== keyName && val).length // 前requiredNum个元素必填，某个元素除主键keyName外存在不为空的属性值时，则该元素的所有属性必填
}

// 注册登录
export const registerAndLoginRules = {
    phone: [
        { required: true, message: getRequiredMsg('手机号码') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('手机号码'))
                !validCellPhone(value) && callback('请输入正确的【手机号码】')
                callback()
            }
        },
    ],
    imgCode: [
        { required: true, message: getRequiredMsg('验证码') },
    ],
    account: [
        { required: true, message: getRequiredMsg('账号') },
    ],
    pwd: [
        { required: true, message: getRequiredMsg('密码') },
    ],
    // isAgree: [
    //     { required: true, message: '请阅读并同意协议' },
    // ],
}

// 修改密码
export const editPasswordRules = {
    oldPwd: [
        { required: true, message: getRequiredMsg('旧密码') },
    ],
    newPwd: [
        { required: true, message: getRequiredMsg('新密码') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('新密码'));
                !validNewPassword(value) && callback('新密码至少8位且必须包含大小写字母、数字和特殊字符')
                callback()
            }
        },
    ],
    confirmPwd: [
        { required: true, message: getRequiredMsg('确认密码') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('确认密码'));
                !validNewPassword(value) && callback('确认密码至少8位且必须包含大小写字母、数字和特殊字符')
                callback()
            }
        },
    ],
}

// 找回密码
export const retrievePasswordRules = {
    account: [
        { required: true, message: getRequiredMsg('系统账号') },
    ],
    phone: [
        {
            validator: (rule, value, callback) => {
                getLen(value) > 20 && callback(getLenMsg('联系电话', 20))
                callback()
            }
        },
    ],
    email: [
        {
            type: "email",
            message: "请输入正确的【邮箱】",
        },
    ],
}

// 平台封面
export const coverRules = {
    fileList: [
        { required: true, message: getRequiredMsg('照片') },
    ],
}

// 企业信息
export const enterpriseRules = {
    companyFullName: [
        { required: true, message: getRequiredMsg('企业全称') },
    ],
    creditCode: [
        { required: true, message: getRequiredMsg('统一社会信用代码') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('统一社会信用代码'));
                getLen(value) > 18 && callback(getLenMsg('统一社会信用代码', 18))
                callback()
            }
        },
    ],
    logo: [
        { required: true, message: getRequiredMsg('企业logo') },
    ],
    shortName: [
        { required: true, message: getRequiredMsg('企业简称') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('企业简称'));
                getLen(value) > 20 && callback(getLenMsg('企业简称', 20))
                callback()
            }
        },
    ],
    introduction: [
        { required: true, message: getRequiredMsg('企业简介') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('企业简介'));
                callback()
            }
        },
    ],
    banner: [
        { required: true, message: getRequiredMsg('企业宣传图上传') },
        {
            validator: (rule, value, callback) => {
                for (let i = 0; i < value.length; i++) {
                    if (value[i].fileList && !value[i].fileList[0]) {
                        callback(getRequiredMsg('企业宣传图上传'));
                    }
                }
                callback()
            }
        },
    ],
    address: [
        { required: true, message: getRequiredMsg('企业地址') },
    ],
}

// 用户角色
export const userRoleRules = {
    enterprise: [
        { required: true, message: getRequiredMsg('企业全称') },
    ],
    shortName: [
        { required: true, message: getRequiredMsg('企业简称') },
    ],
    userRole: [
        { required: true, message: getRequiredMsg('用户角色') },
    ],
    systemUserId: [
        { required: true, message: getRequiredMsg('账号') },
    ],
    // user: [
    //     { required: true, message: getRequiredMsg('用户姓名') },
    // ],
    userName: [
        { required: true, message: getRequiredMsg('用户姓名') },
    ],
    phone: [
        { required: true, message: getRequiredMsg('联系电话') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('联系电话'))
                getLen(value) > 20 && callback(getLenMsg('联系电话', 20))
                callback()
            }
        },
    ],
    email: [
        { required: true, message: getRequiredMsg('邮箱') },
        {
            type: "email",
            message: "请输入正确的【邮箱】",
        },
    ],
}

// 职位
export const positionRules = {
    nature: [
        { required: true, message: getRequiredMsg('职位类型') },
    ],
    isLeader: [
        { required: true, message: getRequiredMsg('是否为领军人才') },
    ],
    name: [
        { required: true, message: getRequiredMsg('职位名称') },
    ],
    positionType: [
        { required: true, message: getRequiredMsg('职位类别') },
    ],
    desc: [
        { required: true, message: getRequiredMsg('职责描述') },
    ],
    requirement: [
        { required: true, message: getRequiredMsg('任职要求') },
    ],
    internshipDate: [
        { required: true, message: getRequiredMsg('期望实习时间') },
    ],
    practiceDays: [
        { required: true, message: getRequiredMsg('期望每周可实习天数') },
    ],
    professionalRequirement: [
        { required: true, message: getRequiredMsg('专业要求') },
    ],
    headcount: [
        { required: true, message: getRequiredMsg('招聘人数') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('招聘人数'));
                // !validNum('招聘人数', value, callback)
                (/[^0-9\u4e00-\u9fa5]/).test(value) && callback('【招聘人数】仅限文字和数字')
                callback()
            }
        },
    ],
    shortName: [
        { required: true, message: getRequiredMsg('企业简称') },
    ],
    city: [
        { required: true, message: getRequiredMsg('所在城市') },
    ],
    workingYears: [
        { required: true, message: getRequiredMsg('工作年限') },
        {
            validator: (rule, value, callback) => {
                value < 0 && callback('请输入正确的【工作年限】')
                callback()
            }
        },
    ],
}

// 简历
export const resumeRules = {
    name: [
        { required: true, message: getRequiredMsg('姓名') },
    ],
    phone: [
        { required: true, message: getRequiredMsg('手机号码') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('手机号码'))
                !validCellPhone(value) && callback('请输入正确的【手机号码】')
                callback()
            }
        },
    ],
    email: [
        { required: true, message: getRequiredMsg('邮箱') },
        {
            type: "email",
            message: "请输入正确的【邮箱】",
        },
    ],
    gender: [
        { required: true, message: getRequiredMsg('性别') },
    ],
    birthdate: [
        { required: true, message: getRequiredMsg('出生日期') },
    ],
    politicalLandscape: [
        { required: true, message: getRequiredMsg('政治面貌') },
    ],
    homeAddress: [
        { required: true, message: getRequiredMsg('户籍地址') },
    ],
    education: [
        { required: true, message: getRequiredMsg('最高学历') },
    ],
    college: [
        { required: true, message: getRequiredMsg('学校全称') },
    ],
    major: [
        { required: true, message: getRequiredMsg('专业') },
    ],
    graduationDate: [
        { required: true, message: getRequiredMsg('毕业时间') },
    ],
    internshipDate: [
        { required: true, message: getRequiredMsg('可实习时间') },
    ],
    practiceDays: [
        { required: true, message: getRequiredMsg('每周可实习') }, ,
        {
            validator: (rule, value, callback) => {
                !validNum('每周可实习', value, callback)
                callback()
            }
        },
    ],
    posType: [
        { required: true, message: getRequiredMsg('职位类型') },
    ],
    workDate: [
        { required: true, message: getRequiredMsg('参加工作年月') },
    ],
    workCompany: [
        { required: true, message: getRequiredMsg('现所在公司') },
    ],
    workDept: [
        { required: true, message: getRequiredMsg('现所在部门') },
    ],
    workPosition: [
        { required: true, message: getRequiredMsg('现职位') },
    ],
    resume: [
        { required: true, message: getRequiredMsg('简历') },
    ],
}

// 职位选择
export const positionSelectRules = {
    position: [
        { required: true, message: getRequiredMsg('候选人职位') },
    ],
}

// 修改信息
export const editInfoRules = {
    userName: [
        { required: true, message: getRequiredMsg('用户姓名') },
    ],
    phone: [
        { required: true, message: getRequiredMsg('联系电话') },
        {
            validator: (rule, value, callback) => {
                !value.trim() && callback(getBlankMsg('联系电话'))
                getLen(value) > 20 && callback(getLenMsg('联系电话', 20))
                callback()
            }
        },
    ],
    email: [
        { required: true, message: getRequiredMsg('邮箱') },
        {
            type: "email",
            message: "请输入正确的【邮箱】",
        },
    ],
}

// 敏感词
export const sensitiveWordRules = {
    word: [
        { required: true, message: getRequiredMsg('敏感词') },
    ],
}

// 清除简历
export const resumeClearRules = {
    date: [
        { required: true, message: getRequiredMsg('结束日期') },
    ],
}

// 
export const dataRangeSelectRules = {
    date: [
        { required: true, message: getRequiredMsg('开始时间') },
    ],
}

export default {
    needValidate,
}